import { RegisterOptions } from "react-hook-form";
import { hasArray } from "src/app/utils/array-utils";
import { hasObject } from "src/app/utils/object-utils";

const defaultErrorMessage = 'Field cannot be empty'

export function isSelectValuePresent(val: any, isMulti?: boolean): boolean {
  if (isMulti) {
    return hasArray(val);
  }
  if (typeof val === 'string') {
    return val.trim().length > 0;
  }
  if (typeof val === 'number' || typeof val === 'boolean') {
    return true;
  }
  if (val && typeof val === 'object') {
    return hasObject(val);
  }
  return false;
}

export function defaultRule({ required, ...rule }: RegisterOptions<any, string> = {}, isMulti?: boolean) {
  const originalValidate = rule.validate;

  if (!!required) {
    const errorMessage = required === true
      ? defaultErrorMessage
      : required;

    rule.validate = (_: any, formValues?: any) => {
      if (!isSelectValuePresent(_, isMulti)) {
        return errorMessage;
      }
      if (typeof originalValidate === 'function') {
        return (originalValidate as any)(_, formValues);
      }
      if (typeof originalValidate === 'object' && originalValidate !== null) {
        for (const key of Object.keys(originalValidate)) {
          const res = (originalValidate as any)[key](_, formValues);
          if (res !== true) return res;
        }
      }
      return true;
    };
  } else if (!originalValidate) {
    rule.validate = undefined;
  }

  return rule;
}
